module.exports = __webpack_public_path__ + "img/6.f88fc411.webp";